var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.54727C1 1.38814 1.06321 1.23552 1.17574 1.123C1.28826 1.01048 1.44087 0.947266 1.6 0.947266H18.4C18.5591 0.947266 18.7117 1.01048 18.8243 1.123C18.9368 1.23552 19 1.38814 19 1.54727V15.3473C19 15.4261 18.9845 15.5041 18.9543 15.5769C18.9242 15.6497 18.88 15.7158 18.8243 15.7715C18.7686 15.8272 18.7024 15.8714 18.6296 15.9016C18.5568 15.9317 18.4788 15.9473 18.4 15.9473H14.26C14.178 15.9471 14.0967 15.9639 14.0214 15.9964C13.9461 16.0289 13.8782 16.0765 13.822 16.1363L10.437 19.7333C10.3809 19.7929 10.3132 19.8404 10.238 19.8729C10.1629 19.9054 10.0819 19.9221 10 19.9221C9.91813 19.9221 9.83712 19.9054 9.76197 19.8729C9.68681 19.8404 9.6191 19.7929 9.563 19.7333L6.178 16.1363C6.1218 16.0765 6.05393 16.0289 5.97859 15.9964C5.90325 15.9639 5.82205 15.9471 5.74 15.9473H1.6C1.44087 15.9473 1.28826 15.8841 1.17574 15.7715C1.06321 15.659 1 15.5064 1 15.3473V1.54727Z",
    stroke: "#0F0E0E",
    strokeWidth: 1.85526
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.94727L11.425 7.52227L14 8.94727L11.425 10.3723L10 12.9473L8.575 10.3723L6 8.94727L8.575 7.52227L10 4.94727Z",
    stroke: "#0F0E0E",
    strokeWidth: 1.85526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature);
export default __webpack_public_path__ + "static/media/feature.b13ef8c81169b081f995e913a0bbd71e.svg";
export { ForwardRef as ReactComponent };